import { AuthenticationFailed, LayoutType, ReservationOrigin, SubscriptionBillingInterval } from 'gleblu-socket-api';

import { SubscriptionState } from '@/models/interfaces/Subscriptions';

import ReservationRejectReason from '../../models/interfaces/reservation/ReservationRejectReason';
import Translation from './Translation';

const romanianTranslation: Translation = {
  menuCategories: 'Categorii de meniu',
  hidden: 'Ascuns',
  categories: 'Categorii',
  accountingHeader: 'Contabilitate',
  aboutSlogen: 'Gestionați-vă rezervările într-un singur loc',
  aboutWhatWeDo: 'Ce facem',
  aboutWhatWeDoText:
    'Gleblu este o platformă de rezervare online. Se potrivește cu oamenii, în căutarea unei mese, cu restaurante. Pe gleblu.ro puteți găsi un loc potrivit, ' +
    'rezervați o masă în câteva secunde și primiți instantaneu confirmare despre rezervare.Verificați orele sau meniul pentru restaurantul preferat sau ' +
    'descoperi locuri noi.',
  aboutUs: 'Despre Gleblu',
  aboutUsText:
    'Gleblu este o companie tânără. În spatele lui Gleblu se află o mică echipă de dezvoltatori de software. ' +
    'Superputerea noastră este că suntem foarte motivați. Faceți cunoștință cu fondatorii.',
  aboutZsolt:
    'Zsolt este CEO-ul Gleblu, un antreprenor tehnologic cu o experiență de peste 3 ani în startup-uri și dezvoltare de software. ' +
    'Deține un Master în Informatică de la ETH Zurich.',
  aboutZsoltJob: 'Operațiunile sensei',
  aboutIstvan:
    'Istvan este CTO al Gleblu, un inginer software cu peste 6 ani de experiență în dezvoltarea de software. El conduce dezvoltarea serviciului nostru. ' +
    'Deține o licență în Inginerie Informațională de la Universitatea Babeș-Bolyai din Cluj-Napoca.',
  aboutIstvanJob: 'Hackerul',
  aboutFindOutMore: 'Află mai multe',
  aboutHeaderInfo: 'Despre noi',
  contactHeader: 'Contacte',
  contactMassMedia: 'Esti parte din mass-media?',
  contactMassMediaText: 'Vrei sa scrii despre Gleblu? Ai nevoie de imagini, logo-uri sau interviuri? Nu ezitati sa ne trimiteti un email la :',
  contactUs: 'Scrie-ne la: ',
  contactRestaurant: 'Esti un restaurant?',
  contactRestaurantText:
    'Gestionați-vă rezervările din mai multe surse (de ex site- ul dvs.web, pagina dvs.de Facebook, Facebook Messenger, gleblu.ro) într-un singur loc! ' +
    'Tu si al tau personalul poate verifica aceste rezervări de pe orice computer, telefon sau tabletă. ' +
    'Puteți accepta sau respinge rezervări din lista de așteptare sau lăsați Gleblu să facă treaba și să automatizeze acest proces ' +
    'pentru a economisi timp tu. Dacă conectați pagina dvs.de Facebook cu chat - ul de chat al lui Gleblu, acesta vă va răspunde oaspeților ' +
    'Messenger, oferă informații despre locul tău și ia rezervări. Încercați gratuit: ',
  contactRelations: 'Relatii Clienti',
  reset: 'Restabilire',
  guestbook: 'Cartea de oaspeți',
  firstName: 'Prenume',
  lastName: 'Nume',
  email: 'Email',
  passwordLabel: 'Parolă',
  initialPasswordLabel: 'Parola inițială',
  errorPageMessage: 'Scuze, ceva a mers greșit.',
  errorPageAction: 'Acasă',
  signupMessage: ['Nu ai încă un cont?', 'Înregistreză acum!'],
  currentTime: 'Astăzi',
  jumpCurrentTime: 'Sari la ziua de azi',
  cancelReservationAction: 'Șterge rezervarea',
  notifyGuest: 'Trebuie să anunți oaspeții înainte de a șterge rezervarea!',
  numberOfGuests: 'Oaspeți',
  table: 'Mese',
  nameLabel: 'Nume',
  phoneNumber: 'Număr de telefon',
  enterPhoneNumber: 'Introdu numărul tău de telefon',
  emailAddress: 'Adresa de email',
  specialRequest: 'Mesaj',
  editAction: 'Editare',
  editGuestAction: 'Editează oaspete',
  noTablesSelected: 'Nu sunt mese selectate',
  reservationDateInThePast: 'Data rezervării în trecut',
  cancelAction: 'Anulare',
  saveAction: 'Salvare',
  editReservationAction: 'Editează rezervarea',
  newReservationAction: 'Rezervare nouă',
  reservationDetails: 'Detaliile rezervării',
  reservationManagementPageTitle: 'Administrarea rezervării',
  tableStateFree: 'Liber',
  tableStatePrepare: 'Pregătire',
  tableStateReserved: 'Rezervat',
  tableStateReady: 'Gata',
  tableStateSeated: 'Aşezat',
  missingPageApology: 'Ne pare rău, dar pagina pe care o cauți lipsește.',
  missingPageExplanations: 'Este posibil că această funcție nu este încă implementată.',
  name: 'Nume',
  address: 'Adresă',
  hoursOfOperation: 'Program',
  website: 'Website',
  menu: 'Meniul',
  websiteInputPlaceholder: 'Introdu linkul site-ului tău',
  menuInputPlaceholder: 'Introdu linkul meniului tău',
  pictures: 'Imagini',
  description: 'Descriere',
  descriptionPlaceHolder: 'Descrie localul tău',
  contact: 'Contact',
  accountMenuItemText: 'Cont',
  generalSettingsMenuItemText: 'General',
  hoursSettingsMenuItemText: 'Program',
  picturesSettingsMenuItemText: 'Imagini',
  reservationSettingsMenuItemText: 'Rezervare',
  layoutSettingsMenuItemText: 'Sala',
  settings: 'Setări',
  websiteForGuestsLink: 'Gleblu',
  aboutLink: 'Despre',
  termsAndConditionsLink: 'Termeni și condiții',
  privacyLink: 'Confidențialitate',
  sendAction: 'Trimite',
  sendFeedbackCallToAction: 'Trimite feedback',
  sendFeedbackDialogTitle: 'Trimite-ne feedback',
  sendFeedbackDialogDescription: 'Completează câmpul de mai jos',
  reservationManagementMenuText: 'Administrare',
  settingsPageManagementMenuText: 'Setări',
  guestsAnalyticsPageManagementMenuText: 'Despre visitors',
  reservationsAnalyticsPageManagementMenuText: 'Datele reservațiilor',
  guestsFrequency: 'Frecvența oaspeților: ',
  firstTimeVisits: 'Vizite pentru prima dată:',
  frequentVsFirstTime: 'Oaspeții frecvenți, comparativ cu primele vizite',
  averageResponseTime: 'Timp mediu de răspuns la rezervările în așteptare:',
  pastReservationsNr: 'Numărul de rezervări anterioare:',
  upcomingReservationsNr: 'Numărul rezervărilor viitoare:',
  pendingReservationsMenuText: 'Lista de așteptare',
  conflictingReservationsMenuText: 'Rezolvarea erorilor',
  languageMenuText: 'Limba',
  addNewPlaceMenuText: 'Adăugă local nou',
  signOutMenuText: 'Deconectare',
  required: 'Necesar',
  mustBeNumeric: 'Număr invalid',
  mustBeUrl: 'Adresa web invalidă',
  mustBePhoneNumber: 'Număr de telefon invalid',
  mustBeEmailAddress: 'Adresa de email invalid',
  maximumAllowedValue: (maxValue: number) => `Valoarea maximă este ${maxValue}`,
  minimumAllowedValue: (minValue: number) => `Valoarea minimă este ${minValue}`,
  alreadyAdded: 'Deja adaugat',
  maximumNumberOfGuestsSettingLabel: 'Număr de oaspeți',
  maximumNumberOfGuestsSentenceStart: 'Permite maxim',
  maximumNumberOfGuestsSentenceEnd: 'pe rezervare',
  maximumNumberOfReservationsSettingLabel: 'Număr de rezervări',
  maximumNumberOfReservationsSentenceStart: 'Permite maxim',
  maximumNumberOfReservationsSentenceEnd: 'simultan',
  durationSettingLabel: 'Durată',
  durationSmallGroupSentenceStart: 'Păstra mesele rezervat pentru',
  durationSmallGroupSentenceEnd: 'pentru 2 persoane',
  durationMediumGroupSentenceStart: 'Păstra mesele rezervat pentru',
  durationMediumGroupSentenceEnd: 'pentru 3-6 persoane',
  durationLargeGroupSentenceStart: 'Păstra mesele rezervat pentru',
  durationLargeGroupSentenceEnd: 'pentru 7+ persoane',
  waitingTimeSettingLabel: 'Timp de așteptare',
  waitingTimeSettingSentenceStart: 'Anularea rezervării dacă oaspetele întârzie',
  minimumLeadTimeSettingLabel: 'Perioada minim de grație',
  minimumLeadTimeSettingSentenceStart: 'Permiteți oaspeților să rezerve o masă minim',
  minimumLeadTimeSettingSentenceEnd: 'în avans.',
  maximumLeadTimeSettingLabel: 'Perioada maxim de grație',
  maximumLeadTimeSettingSentenceStart: 'Permiteți oaspeților să rezerve o masă maxim',
  maximumLeadTimeSettingSentenceEnd: 'în avans',
  preReserveSettingLabel: 'Pre-rezervă',
  preReserveSettingSentenceStart: 'Pregăti masa',
  preReserveSettingSentenceEnd: 'înainte de rezervare.',
  minuteSingular: 'minut',
  minutePlural: 'minute',
  minutePreReserveSingular: 'minut',
  minutePreReservePlural: 'minute',
  hourSingular: 'oră',
  hourPlural: 'ore',
  hourDurationSingular: 'oră',
  hourDurationPlural: 'ore',
  daySingular: 'zi',
  dayPlural: 'zi',
  reservationSingular: 'rezervare',
  reservationPlural: 'rezervări',
  guestSingular: 'oaspete',
  guestPlural: 'oaspeți',
  guests: (numberOfGuests: number) => (numberOfGuests === 1 ? 'oaspete' : 'oaspeți'),
  open: 'deschis',
  closed: 'închis',
  mapView: 'Vizualizare hartă',
  scheduleView: 'Vizualizare program',
  switchToCurrentTime: 'Sari la ziua de azi',
  turnCurrentTimeOff: 'Oprire',
  opensEarlierThanClosesErrorMessage: 'Se deschide mai devreme decât ora de închidere a zilei anterioare',
  closesLaterThanOpensErrorMessage: 'Se închide mai târziu decât ora de deschidere a zilei următoare',
  closedOnThisDate: 'Este închis în acest moment.',
  closedOnThisDay: 'Este închis în această zi.',
  noTableSuggestion: 'Nici o sugestie',
  suggestedTable: 'Sugestie',
  accept: 'Accept',
  reject: 'Respinge',
  changePlan: 'Schimba planul',
  change: 'Schimba',
  resolveAction: 'Rezolva',
  autoResolveAction: 'Rezolvare automată',
  timeCaption: 'Ora',
  vatNumberLabel: 'VAT număr',
  emailAddressPlaceholder: 'exemplu@email.com',
  newPasswordLabel: 'Parolă nouă',
  confirmPasswordLabel: 'Confirma parola',
  passwordTooShort: 'Parola prea scurtă',
  passwordsDoNotMatch: 'Parolele nu se potrivesc',
  weakPasswordNoNumber: 'Parolă slabă: trebuie să conțină un număr',
  weakPasswordNoUppercase: 'Parolă slabă: trebuie să fie o literă majusculă',
  weakPasswordNoLowercase: 'Parolă slabă: trebuie să fie o literă minusculă',
  login: 'Intră',
  contactPerson: 'Persoana de contact',
  company: 'Societate',
  companyName: 'Nume societate',
  register: 'Înregistrare',
  inProgress: 'În progres',
  completed: 'Completat',
  retry: 'Reîncearcă',
  registrationSuccessful: 'Înregistrare reușită',
  registrationFailed: 'Înregistrare eșuată',
  checkConfirmationEmail: 'Verifică contul de email pentru emailul de confirmare.',
  retryLater: 'Te rog să încerci din nou mai târziu',
  emailVerificationFailed: 'Verificarea email eșuată',
  errorOccurred: 'A apărut o eroare',
  tokenInvalidOrExpired: 'Token invalid sau expirat',
  resendToken: 'Retrimite tokenul de activare',
  missingToken: 'Tokenul lipsește',
  emailVerified: 'Email verificat',
  minimumCharacters: (value: number) => `Minim ${value} caractere`,
  submit: 'Trimitere',
  placeNameLabel: 'Numele localului',
  placeNamePlaceholder: 'Introdu numele localului',
  streetLabel: 'Strada',
  streetPlaceholder: 'Introdu numele străzii',
  houseNumber: 'Număr',
  houseNumberPlaceholder: 'Introdu numărul',
  cityLabel: 'Oraș',
  cityPlaceholder: 'Introdu orașul',
  countryLabel: 'Țara',
  countryPlaceholder: 'Introdu țara',
  didYouMean: 'Te-ai gândit la asta',
  selectAction: 'Selectează',
  contributors: 'Contribuitori',
  placeSetupPageTitle: 'Configurare local',
  reservationLayoutTypeLabel: 'Înăuntru sau pe terasă',
  addAction: 'Adăuga',
  modifyAction: 'Modifica',
  tableLabelLabel: 'Etichetă',
  tableCapacityLabel: 'Locuri',
  tableLabelPlaceholder: 'Introdu eticheta',
  tableCapacityPlaceholder: 'Introdu capacitate',
  labelAlreadyTaken: 'Această etichetă este deja luată',
  tables: 'Mese',
  leavePageDialogTitle: 'Lăsați pagina',
  leavePageDialogContent: 'Ai modificări care se vor pierde dacă vei continua.',
  leavePageDialogConfirmAction: 'Lăsați pagina',
  reloadTitle: 'Reîncărcare',
  reloadContent: 'Datele au fost modificate de altcineva. Te rog reîncarcă pagina pentru a continua.',
  reloadAction: 'Reîncărcare',
  addNewReservation: 'Adăuga o rezervare nouă',
  takeSuggestionAction: 'Selecta',
  latitudeLabel: 'Latitudine',
  longitudeLabel: 'Longitudine',
  activationSuccessful: 'Activare reușită',
  activationFailed: 'Activare eșuată',
  enableReservationsSuccessful: 'Rezervările au fost activate cu succes',
  enableReservationsDescription: 'Veți primi un e-mail când oaspeții fac rezervări în aplicația Gleblu',
  enableReservationsFailed: 'Activarea rezervărilor a eșuat',
  disableReservationsSuccessful: 'Rezervările au fost dezactivate cu succes',
  disableReservationsDescription: 'Oaspeții nu vor putea face rezervări în aplicația Gleblu',
  disableReservationsFailed: 'Dezactivarea rezervărilor a eșuat',
  enableGuestWebSuccessful: 'Re-adăugat cu succes',
  enableGuestWebDescription: 'V-am adăugat din nou locul în aplicația Gleblu, oaspeții îl vor putea găsi',
  enableGuestWebFailed: 'Re-adăugarea locului a eșuat',
  disableGuestWebSuccessful: 'Localul eliminat',
  disableGuestWebDescription: 'V-am eliminat localul din aplicația Gleblu, oaspeții nu îl vor mai vedea',
  disableGuestWebFailed: 'Eliminarea localului a eșuat',
  placeLabel: 'Local',
  googlePlaceId: 'Google place id',
  facebookPageToken: 'Facebook page token',
  facebookPageId: 'Facebook page id',
  and: 'și',
  acceptTerm: (button: string) => `Apăsând butonul "${button}", ești de acord cu:`,
  automatic: 'Automat',
  outsideHours: 'Rezervarea este în afară de program',
  durationTooHigh: 'Durată mai mare decât cea implicată',
  durationTooLow: 'Durată mai mică decât cea implicată',
  tableNotAvailable: 'Unele mese nu sunt disponibile',
  capacityTooHigh: 'Numărul de locuri este prea mare',
  capacityTooLow: 'Numărul de locuri este prea mică',
  deleteAction: 'Șterge',
  layoutTypesTitle: {
    [LayoutType.indoor]: 'Înăuntru',
    [LayoutType.outdoor]: 'Terasă',
  },
  loginFailed: {
    [AuthenticationFailed.invalidEmailOrPassword]: 'Autentificare eșuata',
    [AuthenticationFailed.notActivated]: 'Adresa de email nu este confirmat',
  },
  totalCapacity: 'Total locuri',
  timeInterval: 'Mese rezervate',
  reservationDateLabel: 'Data rezervării',
  pageNotFoundTitle: 'Pagina nu a fost găsită',
  placeNotFoundTitle: 'Localul nu a fost găsit',
  placeNotFoundReason: 'Localul nu există.',
  facebookLogin: 'Conectează-te şi selectează pagina ta Facebook!',
  selectedFacebookPage: 'Pagina selectată este:',
  facebookPages: 'Pagini facebook',
  resetStepper: 'Restabili',
  stepperBack: 'Înapoi',
  unknownStep: 'Pas necunoscut',
  firstStep: 'Loghează-te cu Facebook',
  secondStep: 'Selectează pagina Facebook',
  thirdStep: 'Abonează-te la Chatbot',
  chatbotSettingsMenuItem: 'Chatbot',
  automaticReservationMenuItem: 'Rezervare automată',
  automaticReservationDescription: 'Gleblu poate accepta automat rezervările și le poate atribui tabelelor corespunzătoare.',
  tableNotInLayoutType: {
    [LayoutType.indoor]: 'Unele mese nu sunt înăuntru',
    [LayoutType.outdoor]: 'Unele mese nu sunt pe terasă',
  },
  phoneNumberNotSet: 'Numărul de telefon nu este setat',
  guestWebEnabledLabel: 'Vizibilitate',
  guestWebEnabledSwitch: { true: 'Vizibilă pentru oaspeți', false: 'Nu este vizibil pentru oaspeți' },
  acceptsReservationsLabel: 'Rezervare',
  acceptsReservationsSwitch: { true: 'Acivat', false: 'Oprit' },
  autoAcceptReservationLabel: 'Acceptă automat',
  autoAcceptReservation: { true: 'Automat', false: 'Nu automat' },
  guestsArrived: 'Oaspeții au sosit',
  errors: {
    wrongPassword: 'Parolă greșită.',
    emailAddressNotFound: 'Adresa de email nu a fost găsită.',
    invalidToken: 'Token-ul este invalid.',
    expiredToken: 'Token-ul este expirat.',
    operationAlreadyCompleted: 'Operation already completed.',
    placeDisabled: '',
  },
  forgotPasswordLink: 'Ai uitat parola?',
  passwordResetLinkSendingError: 'Nu s-a putut trimite linkul de resetare a parolei!',
  passwordResetLinkSentSuccessfully: 'Linkul de resetare a parolei a fost trimis. Verifică contul de email.',
  passwordResetFailed: 'Nu s-a putut schimba parola',
  passwordResetSuccessful: 'Parolă schimbată. Poți conecta cu noua ta parolă.',
  passwordChangeFailed: 'Nu s-a putut schimba parola',
  noSpecialHours: 'Nu există program special',
  date: 'Date',
  hoursTableHeader: 'Program',
  specialHourDateAlreadyAdded: 'Ai adăugat deja program special pentru această dată',
  announcements: {
    ReservationCreated: 'Rezervarea a fost creată',
    ReservationCreationFailed: 'Nu s-a putut crea rezervarea. Te rog să încerci din nou mai târziu.',
    ReservationOutsideHours: 'Nu s-a putut crea rezervarea, este în afară de program.',
    ReservationUpdated: 'Rezervarea a fost actualizată',
    ReservationUpdateFailed: 'Nu s-a putut actualiza rezervarea. Te rog să încerci din nou mai târziu.',
    ReservationCanceled: 'Rezervarea a fost ștearsă',
    ReservationCancelFailed: 'Nu s-a putut șterge rezervarea. Te rog să încerci din nou mai târziu.',
    ReservationStateUpdated: 'Starea rezervării a fost actualizată.',
    ReservationStateUpdateFailed: 'Nu s-a putut actualiza starea rezervării. Te rog să încerci din nou mai târziu.',
    FeedbackReceived: 'Feedback primit. Mulțumim!',
    FeedbackFailed: 'Nu s-a putut trimite feedbackul tău. Te rog să încerci din nou mai târziu.',
    ContactSaved: 'Setările generale au fost salvate',
    ReservationSettingSaved: 'Setările de rezervare au fost salvate',
    ProfileSaved: 'Imaginile salvate',
    LayoutSaved: 'Mesele salvate',
    EmployeeUpdated: 'Permisiunile angajatului salvate',
    EmployeeUpdateFailed: 'Nu s-a putut actualiza permisiunile angajatului',
  },
  employees: 'Angajați',
  permissions: 'Permisiuni',
  assignedTables: 'Mese alocate',
  workingSchedule: 'Program de lucru',
  permissionLevels: { unauthorized: 'Neautorizat', view: 'Vizualizare', edit: 'Editare' },
  reservationPermission: 'Permisiunea rezervare',
  settingPermission: 'Permisiunea setări',
  emptyDataSourceMessage: 'Nu există înregistrări de afișat',
  filterTooltip: 'Filtru',
  rowDeleteConfirmation: 'Sigur dorești să ștergi acest rând?',
  actionsTooltip: 'Operațiuni',
  groupedBy: 'Grupate de',
  dragHeaders: 'Tragi anteturile',
  firstPage: 'Prima pagină',
  previousPage: 'Pagina precedentă',
  nextPage: 'Pagina următoare',
  lastPage: 'Ultima pagină',
  displayedRowsLabel: '{from}-{to}: {count}',
  rowsPerPageLabel: 'Rânduri pe pagină',
  rowsLabel: 'Rânduri',
  addOrRemoveColumns: 'Adăugare sau eliminare coloane',
  showColumns: 'Afișare coloane',
  exportTooltip: 'Export',
  exportAsCsv: 'Exporta ca CSV',
  searchTooltip: 'Căutare',
  deletePermissionRowConfirmation: 'Sigur dorești să ștergi acestă permisiune?',
  noProfileImage: 'Nicio imagine profil',
  uploadTakesTime: 'Te rog, ai răbdare. Încărcarea poate dura ceva timp.',
  employeesToBeInvited: 'Angajații care urmează să fie invitați',
  alreadyInvited: 'Deja invitat',
  emailTextAreaPlaceholder: 'Tasta sau lipi adrese de email și apăsa "Enter"',
  extractEmails: 'Adăuga emailuri',
  noEmailsFoundInInput: 'Nu s-a putut găsi nici un email',
  inviteEmployeesSubmitError: 'Nu s-a putut invita angajați',
  originTitle: {
    [ReservationOrigin.chatbot]: 'Facebook Messenger',
    [ReservationOrigin.facebookTab]: 'Facebook Tab',
    [ReservationOrigin.guestWeb]: 'Gleblu.ro',
    [ReservationOrigin.guestApp]: 'Gleblu App',
    [ReservationOrigin.placeWeb]: 'Gleblu Business',
    [ReservationOrigin.webWidget]: 'Web widget',
    [ReservationOrigin.authenticatedGuestWeb]: 'Gleblu.ro Autenticat',
  },
  unauthorizedToViewReservations: 'Nu ai permisiunea de a vizualiza rezervările',
  unauthorizedToViewPlaceSettings: 'Nu ai permisiunea de a vizualiza setările localului',
  unauthorizedToViewCompanySettings: 'Nu ai permisiunea de a vizualiza setările companiei',
  unauthorizedToAddPlaces: 'Nu ai permisiunea de a adăuga un local nou',
  unauthorizedToViewPlace: 'Nu ai permisiunea de a accesa localul',
  createdBy: 'Creat de',
  updatedBy: 'Actualizat de',
  nextDay: 'ziua următoare',
  notAvailable: 'Not available',
  reservationRejectReasons: {
    [ReservationRejectReason.OutsideHours]: 'Rezervarea este în afară de program',
    [ReservationRejectReason.Unknown]: 'A apărut o eroare',
  },
  loggedInGreeting: 'Bună! Cum te putem ajuta?',
  loggedOutGreeting: 'Bună! Cum te putem ajuta?',
  landingPageTitle: 'Gestionează rezervările într-un singur loc!',
  landingPageSubtitle: 'De pe site-ul tău, pagina ta de Facebook, Facebook Messenger, căutarea și harta Google, gleblu.ro',
  learnMore: 'Află mai multe',
  userHasAccount: 'Ai deja un cont?',
  landingPageWaitingTexts: [
    'Tu și personalul tău pot verifica aceste rezervări de pe orice computer, laptop, POS, telefon sau tabletă.',
    'Tot ce ai nevoie este un browser web.',
    'Pot accepta sau respinge rezervările din lista de așteptare' +
      ' sau pot lăsa Gleblu să efectueze munca și să automatizeze acest proces pentru a economisi timp pentru tine.',
  ],
  landingPageChatbotTexts: [
    'Dacă conectezi pagina ta de Facebook cu chatbotul Gleblu, acesta vă va răspunde oaspeților tăi de pe Messenger,' +
      ' va oferi informații despre localul tău și va prelua rezervări.',
  ],
  errorsResolved: 'Toate erorile au fost rezolvate',
  seatingStartsBeforeOpening: 'Rezervarea începe înainte de ora de deschidere',
  seatingEndsAfterClosing: 'Rezervarea continuă după ora de închidere',
  layoutClosed: 'Sala este închisă',
  languages: {
    en: 'Engleză',
    hu: 'Maghiară',
    ro: 'Română',
  },
  userNotAddedToPlaces: 'Nu ești adăugat la niciun local',
  contactAdministrator: 'Te rog să contactezi administratorul de sistem',
  layoutLabel: 'Etichetă',
  layoutTypeLabel: 'Înăuntru sau pe terasă',
  availability: 'Disponibilitate',
  createLayoutTitle: 'Adăuga o sală',
  stringMaximumLength: (maxLength: number) => `Lungimea maximă permisă este ${maxLength}`,
  pricingDescription: 'Alegeți un abonament care se potrivește cazului dvs',
  pricingTitle: {
    [SubscriptionBillingInterval.MONTH]: 'Lunar',
    [SubscriptionBillingInterval.YEAR]: 'Anual',
  },
  pricingInterval: {
    [SubscriptionBillingInterval.MONTH]: 'pe lună',
    [SubscriptionBillingInterval.YEAR]: 'pe an',
  },
  subscriptionState: {
    [SubscriptionState.ACTIVE]: 'Activ',
    [SubscriptionState.UNDETERMINED]: 'Nedeterminat',
    [SubscriptionState.TERMINATED]: 'Inactiv',
  },
  currentSubscription: 'Abonament curent:',
  activeUntil: (date: string) => `până la ${date}`,
  subscribe: 'Aboneaza-te',
  resubscribe: 'Reabonare',
  staySubscribed: 'Rămâi abonat',
  trialDescription: 'Primele 30 de zile sunt gratuite',
  chatbotDescription: [
    'Mai întâi, conectați Gleblu cu pagina dvs. de Facebook, apoi vă veți putea abona la chatbot-ul nostru.',
    'Chatbot-ul nostru poate vorbi cu clienții tăi prin Messenger în trei limbi diferite: engleză, română și maghiară.',
    'De asemenea, poate accepta rezervări de masă pentru dvs.',
  ],
  processingSubscription: 'Se procesează abonamentul...',
  changeInitialPasswordTitle: 'Schimbați parola inițială',
  changeInitialPasswordExplanation: 'Din motive de securitate, trebuie să vă schimbați parola inițială înainte de a vă accesa contul.',
  hoursRequired: `Pentru a gestiona rezervările, vă rugăm să specificați mai întâi programul de lucru al restaurantului.`,
  hoursSet: `Acum că ați setat orele de deschidere, puteți activa rezervările`,
  defineLayoutDescription: 'Rezervarea automată trebuie să cunoască aspectul și tabelele locului.',
  rejectReservationFailed: 'Respingerea rezervării a eșuat',
  acceptReservationFailed: 'Acceptarea rezervării a eșuat',
  reservationConfirmationDescription: 'Puteți vizualiza toate rezervările în aplicația Gleblu după ce vă conectați',
  reservationRejectedSuccessfully: 'Rezervarea a fost respinsă cu succes',
  reservationAcceptedSuccessfully: 'Rezervarea a fost acceptată cu succes',
  reservationExpired: 'Rezervarea a expirat deja',
  reservationNotPending: 'Rezervarea este deja acceptată sau respinsă',
  reviewRequiredPageTitle: 'Este necesară verificarea',
  reviewRequiredPageContent: (placeName) => [
    `'${placeName}' este în curs de verificare de către echipa Gleblu.`,
    `Te vom anunța prin e-mail imediat ce verificarea este finalizată și pagina ta este aprobată.`,
    `Îți mulțumim pentru răbdare.`,
  ],
  delete: 'Șterge',
  deleteAccountDialogTitle: 'Șterge contul',
  deleteAccountDialogContent: 'Ești sigur că dorești să ștergi contul?',
  deactivatedAccount: 'Cont dezactivat',
  deactivatedAccountPageParagraphs: [
    'Contul tău a fost dezactivat.',
    'Nu te vei putea autentifica sau accesa profilul până când contul nu va fi reactivat.',
    `Este posibil ca unele funcționalități să fi fost dezactivate odată cu contul tău. ` +
      `După reactivarea contului, te rugăm să le verifici în secțiunea 'Setări'.`,
  ],
  reactivate: 'Reactivează',
  accountDeletionSucceeded: 'Contul tău a fost șters cu succes.',
  accountDeletionFailed: 'Nu am putut să îți ștergem contul.',
  deleteYourAccount: 'Șterge-ți contul',
  deleteYourAccountParagraphs: [
    'Dacă nu mai dorești să utilizezi serviciul nostru, îți poți șterge contul.' +
      ' Vom păstra datele tale personale pentru o perioadă limitată, înainte de a le șterge definitiv.',
    "Te-ai răzgândit? Îți poți reactiva contul conectându-te și apăsând butonul 'Reactivează', atât timp cât datele tale personale sunt încă disponibile.",
  ],
};

export default romanianTranslation;
